import React from 'react'

import AIChatMessage from "../../../../../../core/model2/ai/chat-message/chat-message"
import RichTextEditorUniversal from "../../../../../../core/gd-components/editor-universal/editor-universal"
import {RTFVersion} from "../../../../../../core/gd-components/editor/@type"
import AIChatMessageDebug from "../../debug/message-debug"
import AIChatMessage_Collection from "../../../../../../core/model2/ai/chat-message/collection"
import AiChatModule from "../../../../../../core/gd-modules/ai-chat/ai-chat"
import AiAgentAvatar from "../../../agent-avatar"
import {DEFAULT_AGENT_LABEL} from "../../../../@const"

type Props = {
    message                 : AIChatMessage
    debugMessageCollection? : AIChatMessage_Collection
    module                  : AiChatModule
}

// const debug = "AIChatAnswerMessage"
const debug = false

export default function AIChatAnswerMessage(props: Props) {

    debug && console.log(debug, "props.module.chatDebugEnabled", props.module.chatDebugEnabled)

    const agentId   = props.message.agentId ?? props.module.agentId
    const agent     = agentId ? gd.session.aiAgents.get(agentId) : null
    const agentName = agent?.name ?? DEFAULT_AGENT_LABEL

    const messageRTF = {
        markdown    : props.message.message,
        v           : RTFVersion.MARKDOWN
    }

    return (
        <>
            <div className="">
                <div className="flex-row-left-center m-b-5">
                    <AiAgentAvatar agentId={agentId} size={24}/>
                    <div className="ui5-txt-less-important ui5-txt-bold m-l-8 m-r-10">
                        {agentName}
                    </div>


                    {
                        props.module.chatDebugEnabled &&
                        !!props.debugMessageCollection && (
                            <AIChatMessageDebug messageCollection={props.debugMessageCollection}/>
                        )
                    }
                </div>

                <div className="ui5-txt-default pre-line" style={{marginLeft: 32}}>
                    <RichTextEditorUniversal
                        className      = {Classes('gd-textarea-rte')}
                        editable       = {false}
                        messageText    = {props.message.message}
                        messageRTF     = {messageRTF}
                    />
                </div>
                <div>

                </div>


            </div>

        </>
    );
}
